import gql from "graphql-tag";

import {useQuery} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {checkPromotionType} from "./__graphql-types__/index.ts";

export const USE_PROMOTION_QUERY: GqlOperation<
    checkPromotionType["response"],
    checkPromotionType["variables"]
> = gqlOp(gql`
    query checkPromotion($promoName: String!) {
        user {
            id
            promotion(promoName: $promoName)
        }
    }
`);

export const usePromotionQuery = (
    promoName: string,
    skip: boolean,
): boolean => {
    const [result] = useQuery(USE_PROMOTION_QUERY, {
        variables: {promoName},
        skip,
    });

    if (result.status !== "success") {
        return false;
    }

    return result.data.user?.promotion ?? false;
};
